export enum RegisterProcessesType {
  SaveUser = 1,
  ValidateEmailWithAPI,
  CreateMXUser,
  ImportLead,
  PreAuth,
  ImportOrder,
  ImportUpsale,
  SendEverflowEvent,
}